import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=77f6b584&scoped=true"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=77f6b584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f6b584",
  null
  
)

export default component.exports